import React from 'react';
import { SortOption, sortOptions, categoryOptions, CatalogQuickFilter, quickFilterOptions } from '../catalogTypes';
import { CatalogSearch } from './CatalogSearch';
import { CatalogDropdown } from './CatalogDropdown';
import styles from './CatalogFilters.module.css';

interface CatalogFiltersProps {
  search: string;
  onSearchChange: (value: string) => void;
  category: string;
  onCategoryChange: (value: string) => void;
  sort: SortOption;
  onSortChange: (value: SortOption) => void;
  quickFilter: CatalogQuickFilter;
  onQuickFilterChange: (value: CatalogQuickFilter) => void;
}

export const CatalogFilters: React.FC<CatalogFiltersProps> = ({
  search,
  onSearchChange,
  category,
  onCategoryChange,
  sort,
  onSortChange,
  quickFilter,
  onQuickFilterChange,
}) => {
  return (
    <div>
      <div className={styles.bar}>
        <CatalogSearch value={search} onChange={onSearchChange} />
        <CatalogDropdown
          options={categoryOptions}
          value={category}
          onChange={onCategoryChange}
        />
        <CatalogDropdown
          options={sortOptions}
          value={sort}
          onChange={(v) => onSortChange(v as SortOption)}
        />
      </div>
      <div
        role="tablist"
        aria-label="Catalog quick filters"
        style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginTop: 10 }}
      >
        {quickFilterOptions.map((opt) => (
          <button
            key={opt.value}
            type="button"
            role="tab"
            aria-selected={quickFilter === opt.value}
            onClick={() => onQuickFilterChange(opt.value)}
            style={{
              padding: '6px 14px',
              borderRadius: 999,
              border: quickFilter === opt.value ? '1px solid #2563EB' : '1px solid #D1D5DB',
              background: quickFilter === opt.value ? '#EFF6FF' : '#fff',
              color: quickFilter === opt.value ? '#1D4ED8' : '#374151',
              fontSize: 13,
              fontWeight: 600,
              cursor: 'pointer',
            }}
          >
            {opt.label}
          </button>
        ))}
      </div>
    </div>
  );
};
